module.exports = __webpack_public_path__ + "media/As8.9d67aee9.wav";